import { Typography } from '@mui/material';

export default function Subtitle1({ children, style }) {
  return (
    <Typography
      variant="subtitle1"
      style={{ ...style }}
      gutterBottom
      component="div">
      {children}
    </Typography>
  );
}
